import { VideoWithReviewDataResponseDto } from '@/app/common/general-types/videos.dto';
import { Component, inject, OnInit, signal } from '@angular/core';
import { VideoStatusEnum } from '@/app/common/general-types/videos.dto';
import { ImageService } from '@/app/services/image/image.service';
import { FormatService } from '@/app/common/format/format.service';
import { VideoService } from '@/app/services/video/video.service';
import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { MgcPortfolioInlineVideoComponent } from '@/app/pages/creators/molecules/creator-profile/mgc-portfolio/mgc-portfolio-inline-video.component';
import { Router } from '@angular/router';

@Component({
  selector: 'dbv2-videos-to-review',
  standalone: true,
  imports: [MgcPortfolioInlineVideoComponent],
  templateUrl: './videos-to-review.html',
  styleUrl: './videos-to-review.scss',
})
export class VideosToReview implements OnInit {

  VideoStatusEnum = VideoStatusEnum;
  videosToReview = signal<VideoWithReviewDataResponseDto[] | undefined>(undefined); 

  /** Services */
  private router = inject(Router);
  private videoService = inject(VideoService);
  private currentUserService = inject(CurrentUserService);
  public imageService = inject(ImageService);
  public formatService = inject(FormatService);
  /** Services - END */

  constructor() {
    this.currentUserService.focussedBrandSubject.pipe(
      debounceTime(350),
      distinctUntilChanged()
    ).subscribe((brand: any) => {
      console.log('🎃🎃🎃🎃 DE - Bounce - VIDEOS TO REVIEW: ', brand);
      if (brand) {
        this.getNewVideos();
      }
    });
  }

  ngOnInit() {
    this.getNewVideos();
  }

  getNewVideos() {
    this.videoService.getLatestApplicationVideos({
      businessAccountId: this.currentUserService.focussedBrand.id,
      skip: 0,
      take: 10,
      status: [VideoStatusEnum.New],
    }).subscribe((videos) => {
      console.log('👮🏻‍♂️👮🏻‍♂️ New videos:', videos);
      this.videosToReview.set(videos);
    });
  }

  goToViewSubmission(video: VideoWithReviewDataResponseDto) {
    this.router.navigate(['/view-submission', video.briefId, video.creator.blazeFirebaseUid]);
  }
}
